var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9945 11C20.9945 16.7974 16.2954 21.4948 10.4997 21.4948C4.70397 21.4948 0.00488281 16.7974 0.00488281 11C0.00488281 5.20603 4.70397 0.505249 10.4997 0.505249C16.2954 0.505249 20.9945 5.20603 20.9945 11ZM10.4997 13.1159C9.42459 13.1159 8.55306 13.9875 8.55306 15.0625C8.55306 16.1376 9.42459 17.0092 10.4997 17.0092C11.5748 17.0092 12.4463 16.1376 12.4463 15.0625C12.4463 13.9875 11.5748 13.1159 10.4997 13.1159ZM8.96545 11.8741L8.65153 6.11886C8.63566 5.82797 8.86723 5.58337 9.15854 5.58337H11.8408C12.1321 5.58337 12.3637 5.82797 12.3478 6.11886L12.0339 11.8741C12.0192 12.1434 11.7965 12.3542 11.5269 12.3542H9.4725C9.20281 12.3542 8.98013 12.1434 8.96545 11.8741Z",
    fill: "#D0021B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning-icon.53004674a2ba70f97cf1b4d08c872f51.svg";